/**
 * Enable Copy Paste - E.C.P — re-enables copy/paste and right-click
 *
 * Declares a single web-accessible-resource entry matched to http(s) origins with no
 * `use_dynamic_url`, exposing exactly two vendor-named scripts under
 * `content_script_web_accessible/`: `ecp_regular.js` and `ecp_aggressive.js`. Both are
 * reachable from any http(s) page at a fixed URL.
 *
 * No image is exposed, so the primary signal is a fetch of the `ecp_`-prefixed regular
 * content script — the prefix makes the path distinctive to this extension.
 *
 * Manifest verified against version 2.0.0.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'fpjppnhnpnknbenelmbnidjbolhandnf';

export const enableCopyPaste: ExtensionDefinition = {
  id: ID,
  name: 'Enable Copy Paste - E.C.P',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Two ecp_-prefixed scripts exposed to http(s) origins with no dynamic URL. ' +
    'A single fetch of either is conclusive.',
  signals: [
    {
      id: 'war-ecp-regular-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content_script_web_accessible/ecp_regular.js — a vendor-namespaced (ecp_) ' +
        'script exposed to every http(s) origin. The prefix makes the path distinctive.',
      weight: 1,
      run: () => probeFetch(ID, 'content_script_web_accessible/ecp_regular.js'),
    },
    {
      id: 'war-ecp-aggressive-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content_script_web_accessible/ecp_aggressive.js — the aggressive-mode ' +
        'variant, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content_script_web_accessible/ecp_aggressive.js'),
    },
  ],
};
